import * as React from 'react'

import { AltPad, Box, Text } from '@factorialco/deprecated-design-system'

import TooltipPortal from 'modules/core/components/DraggableNode'
import useMouseCoords from 'modules/core/hooks/useMouseCoords'

type Props = { label: string }

const Tooltip = ({ label }: Props) => {
  const coordinates = useMouseCoords()

  return (
    <>
      <TooltipPortal coordinates={coordinates}>
        <Box borderRadius={{ all: 'abs008' }} overflowX="hidden" overflowY="hidden">
          <AltPad
            label={
              <Text.Normal color="grey000White" size="100">
                {label}
              </Text.Normal>
            }
          />
        </Box>
      </TooltipPortal>
    </>
  )
}

export default Tooltip
